function work() {
  var controller = new ScrollMagic.Controller();

  anime({
    targets: '.hero .animate-down',
    translateY: [-100,0],
    easing: "easeOutExpo",
    opacity: {
      value: [0, 1],
      duration: 1000,
      easing: 'linear',
    },
    duration: 1400,
    delay: function(el, i) {
      return 50 * i;
    }
  });

  anime({
    targets: '.hero .animate-up',
    translateY: [100,0],
    opacity: {
      value: [0, 1],
      duration: 1000,
      easing: 'linear',
    },
    delay: 100,
    easing: "easeOutExpo",
    duration: 1400
  });

  $('.play').modalVideo();

  new ScrollMagic.Scene({
    triggerElement: '.blocks',
    triggerHook: 0.9,
    offset: 50,
    reverse: false
  })
  .setClassToggle('.block', 'visible')
  .addTo(controller);

  new ScrollMagic.Scene({
    triggerElement: '.early-access',
    triggerHook: 0.9,
    offset: 50,
    reverse: false
  })
  .setClassToggle('.early-access', 'visible')
  .addTo(controller);
}

if( document.readyState !== 'loading' ) {
  work();
} else {
  document.addEventListener('DOMContentLoaded', function () {
      work();
  });
}
